export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";